import { BaseApi } from '@smorder/logic';

class SignageApi extends BaseApi {
  * loadOrdersForSignage(locationId) {
    return yield this.apiFetch(`/api/v1/location/${locationId}/OrdersForSignage`, {
      method: 'GET',
      headers: {
        ...this.jsonHeaders().headers,
      }
    });
  }
}

export default SignageApi;
